import { PropsWithChildren } from 'react'
import styled from '@emotion/styled'
import { Link } from 'react-router-dom'

import color from '../../../constant/colors'
import Text from '../../common/Text'

type MenuType = {
  isActive: boolean
  isHidden?: boolean
  path: string
}

const Layout = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  border-style: solid;
  border-width: 0px;
  border-bottom-width: 2px;
  border-bottom-color: transparent;

  :hover {
    cursor: pointer;
    /* border-bottom-color: ${color.PRIMARY}; */

    .menu-label {
      color: ${color.PRIMARY};
    }
  }

  &.active {
    cursor: default;
    border-bottom-color: ${color.CHOICES_PRIMARY};

    .menu-label {
      color: ${color.CHOICES_PRIMARY};
    }

    :hover {
      cursor: default;
    }
  }

  &.hidden {
    display: none !important;
  }
`

const CustomText = styled(Text)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
  height: 38px;
  border-radius: 19px;
  color: ${color.FONT_BLACK};
`

const Menu = (props: PropsWithChildren<MenuType>) => {
  const { isActive, isHidden, children, path, ...rest } = props
  return (
    <Layout {...rest} className={`${isActive ? 'active' : ''} ${isHidden ? 'hidden' : ''}`}>
      <Link to={path}>
        <CustomText className="menu-label" type="Bold">
          {children}
        </CustomText>
      </Link>
    </Layout>
  )
}

export default Menu
